import { IDSIconArrow as i } from "./icon-arrow-element.js";
import { registerComponent as o } from "../../../utilities/utils.js";
o("ids-icon-arrow", i);